'use client';

import React from 'react';

import Masonry from '@repo/ui/masonry';

import { ReviewCollection } from 'types/sanity.types';

import ReviewItem from '../review-item';

type TProps = {
  reviews?: ReviewCollection[];
};

const ReviewsMasonry = (props: TProps) => {
  const { reviews } = props;

  return (
    <Masonry
      items={reviews ?? []}
      config={{
        columns: [1, 2, 3],
        gap: [12, 24, 24],
        media: [640, 1280, 1280],
      }}
      render={(review: ReviewCollection, index: number) => (
        <ReviewItem key={`${review._id}-${index}`} review={review} />
      )}
    />
  );
};

export default ReviewsMasonry;
